import { render, staticRenderFns } from "./UserRings.vue?vue&type=template&id=f4c2ddf2&"
import script from "./UserRings.vue?vue&type=script&lang=js&"
export * from "./UserRings.vue?vue&type=script&lang=js&"
import style0 from "./UserRings.vue?vue&type=style&index=0&id=f4c2ddf2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports